import { useCallback } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import useWorkspaceStore from "stores/useWorkspaceStore";

const useWorkspaceActionsPanelNavigator = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { setActionsPanelFilter } = useWorkspaceStore();

  return useCallback(
    ({ heading, actionIds }) => {
      if (!Array.isArray(actionIds) || actionIds.length === 0) return;

      setActionsPanelFilter({
        heading,
        actionIds,
      });

      if (location.pathname !== "/workspace") {
        navigate("/workspace");
      }
    },
    [location.pathname, navigate, setActionsPanelFilter]
  );
};

export default useWorkspaceActionsPanelNavigator;
